import { render, staticRenderFns } from "./pay.vue?vue&type=template&id=b6ef7e6a"
import script from "./pay.vue?vue&type=script&lang=js"
export * from "./pay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports